import { apiRequest } from './apiRequest';
import type { AccessRequest, AccessRequestsListResponse } from '../../types/api/accessRequests';

export const accessRequestsAPI = {
  submitRequest: (body: Record<string, unknown>) =>
    apiRequest<any>('/api/access-requests', {
      method: 'POST',
      body: JSON.stringify(body),
      skipAuth: true,
    }),

  getRequests: async (orgId: string): Promise<AccessRequest[]> => {
    const data = await apiRequest<AccessRequestsListResponse>(
      `/api/organisations/${encodeURIComponent(orgId)}/access-requests`,
      { method: 'GET' },
    );
    return data.requests ?? [];
  },

  grantRequest: (orgId: string, requestId: string) =>
    apiRequest<any>(
      `/api/organisations/${encodeURIComponent(orgId)}/access-requests/${encodeURIComponent(requestId)}/grant`,
      { method: 'POST', body: JSON.stringify({}) },
    ),
};
